import { createContext } from 'react';

import { BouncedEmail } from '@totem/components/administration/bouncedEmails/types';

interface Context {
  loading: boolean;
  data: BouncedEmail[];
  totalRecords: number;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  totalRecords: 0,
  onRefresh: () => {},
});
